import z from 'zod';

const categorySchema = z.object({
  valueType: z.string(),
  displayName: z.string(),
  value: z.string(),
  count: z.string().nullable(),
  rangeKey: z.string().nullable(),
});

const SearchFilterValueSchema = z.object({
  valueType: z.string(),
  displayName: z.string().optional(),
  value: z.string().optional(),
  type: z.string().optional(),
  from: z.array(categorySchema).optional(),
  to: z.array(categorySchema).optional(),
  all: z.array(categorySchema).optional(),
  popular: z.array(categorySchema).optional(),
  pricePerMonthFrom: z.array(categorySchema).nullish(),
  pricePerMonthTo: z.array(categorySchema).nullish(),
  count: z.string().nullish(),
  rangeKey: z.string().nullish(),
});

const searchFilterSchema = z.object({
  id: z.number().nullable(),
  name: z.string(),
  displayName: z.string(),
  hideDisplayName: z.boolean().optional(),
  variant: z.enum([
    'DONEDEAL_DEFAULT',
    'DONEDEAL_TAG',
    'DONEDEAL_RADIO',
    'DONEDEAL_IMAGE',
    'DONEDEAL_MAKE_MODEL',
    'DONEDEAL_PRICE_DROPDOWN',
    'DONEDEAL_PRICE_DROPDOWN_PPM',
    'DONEDEAL_PRICE_CHECKBOX',
    'HIDDEN',
    'DONEDEAL_CHECKBOX',
  ]),
  searchQueryGroup: z.enum([
    'filters',
    'ranges',
    'makeModel',
    'terms',
    'andFilters',
  ]),
  type: z.enum(['filter', 'group']).nullable(),
  filterType: z.object({
    id: z.number().nullable(),
    name: z.string(),
  }),
  values: z.array(SearchFilterValueSchema),
  displayHint: z.string().nullable(),
  maxLength: z.number().nullable(),
  showCount: z.boolean(),
  openByDefault: z.boolean(),
  trailingIcon: z
    .object({
      name: z.string(),
      url: z.string(),
      text: z.string().optional(),
    })
    .nullable(),
  leadingIcon: z
    .object({
      name: z.string(),
      url: z.string(),
    })
    .nullable(),
  showMoreLabel: z.boolean().nullable(),
  field: z.string().nullish(),
});

const searchFilterWithSubFiltersSchema = searchFilterSchema.merge(
  z.object({
    subFilters: z.array(searchFilterSchema).nullish(),
  }),
);

export const showroomFiltersSchema = z.object({
  name: z.string(),
  showByDefault: z.array(searchFilterWithSubFiltersSchema),
  sortFields: z.array(
    z.object({
      name: z.string(),
      displayName: z.string(),
    }),
  ),
});

export type ShowroomFilters = z.infer<typeof showroomFiltersSchema>;
